module.exports = __webpack_public_path__ + "assets/6eee68bc62167530941180ee62a0a275.png";